import {Component, Output, Input, EventEmitter, OnInit} from "@angular/core";
import {kelvinToRgb} from "../../../../utils/convert-kelvin";

@Component ({
    selector: 'kelvin-input',
    templateUrl: './kelvin.component.html',
    styleUrls: ['./kelvin.component.scss']
})

export class KelvinComponent implements OnInit {
    @Output() kelvinChange = new EventEmitter<number>();
    @Input() defaultKelvin: number = 2500;
    @Input() minKelvin: number = 1200;
    @Input() maxKelvin: number = 4000;
    @Input() initialKelvin: number | string = this.defaultKelvin;
    public currentKelvin: number;
    public borderColor: string;

    ngOnInit() {
        this.setKelvinValue(Number(this.initialKelvin));
    }

    public onKelvinChange(event: Event): void {
        const target = event.target as HTMLInputElement;
        this.setKelvinValue(parseInt(target.value, 10))
        this.kelvinChange.emit(this.currentKelvin);
    }

    private setKelvinValue(value: number) {
        if(!value || typeof value === 'undefined' || value === 0){
            this.currentKelvin = this.defaultKelvin;
        } else {
            this.currentKelvin = Math.min(Math.max(value, this.minKelvin), this.maxKelvin);
        }
        this.setBackgroundColor();
    }

    private setBackgroundColor():void{
        const { r, g, b } = kelvinToRgb(this.currentKelvin);
        this.borderColor = `rgb(${r}, ${g}, ${b})`;
    }
}
